import { ChangeDetectorRef, Pipe, PipeTransform, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { translate } from '@thiememeulenhoff/translations';
import { tap } from 'rxjs';
import { LanguageService } from './language.service';

@Pipe({
  name: 'translate',
  standalone: true,
})
export class TranslatePipe implements PipeTransform {
  readonly #changeDetector = inject(ChangeDetectorRef);

  readonly #languageService = inject(LanguageService);

  readonly #languageChange = this.#languageService.currentLanguage$.pipe(
    tap(() => this.#changeDetector.markForCheck()),
    takeUntilDestroyed(),
  );

  constructor() {
    this.#languageChange.subscribe();
  }

  // eslint-disable-next-line class-methods-use-this
  transform(value: string | undefined | null, options = {}): string {
    if (!value) {
      return '';
    }

    return translate(value, options);
  }
}
